module.exports = __webpack_public_path__ + "static/img/bg-1.ee25f9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgaofu/bnaner/bg-1.png
// module id = KZKs
// module chunks = 0